import { DecimalPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "campaignDiscount",
})
export class CampaignDiscountPipe implements PipeTransform {
  constructor(
    private decimalPipe: DecimalPipe,
    private translateService: TranslateService,
  ) {}

  transform(discount?: number): string {
    if (discount === undefined) return "";
    const adjusted = Math.ceil(discount! * 100);

    return `${this.decimalPipe.transform(
      adjusted,
      "",
      "sv-SE",
    )} ${this.translateService.instant("price.discount")}`;
  }
}
